import React, { useState } from "react";
import "./Home.css";

import { SubscribeEmailModal } from "./SubscribeEmailModal";
import { SubscribeNumberModal } from "./SubscribeNumberModal";
import { useNavigate } from "react-router-dom";
import { getLocale, setLocale } from "./i18nRefs.jsx";
import { dict } from "./i18n";
import Header from "./Header.js";
import Footer from "./Footer.js";

function HomeScreen() {
  let navigate = useNavigate();
  const [showEmail, setShowEmail] = useState(false);
  const [showSms, setShowSms] = useState(false);
  const [locale, setLocalLocale] = useState(getLocale());
  const [i18n, seti18n] = useState(dict[getLocale()]);

  const gotowarnigsshistory = () => {
    let path = `../warnings`;
    navigate(path);
  };

  return (
    <div id="app" className="vh-100 min-vh-100" style={styles.app}>

      <div style={styles.header}>
        <Header activeKey={"home"} />
      </div>


      <div id="body" className="text-center align-middle" style={styles.body}>

        <h3>{i18n.SIGNUPTEXT}</h3>
        <div className="col-lg-6 mx-auto">
          <p className="lead mb-4">{i18n.CLICK_APPR_TEXT}</p>
          <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
            <button
              type="button"
              className="btn btn-primary btn-lg px-4 gap-3"
              onClick={() => setShowEmail(true)}
            >
              {i18n.EMAIL}
            </button>

            <button
              type="button"
              className="btn btn-primary btn-lg px-4 gap-3"
              onClick={() => setShowSms(true)}
            >
              {i18n.TEXT_MESSAGE}
            </button>
          </div>
        </div>

        <div className={"col-lg-10 mx-auto"} style={styles.disclaimer}>
          {/* FIXME: use of dangerouslySetInnerHTML */}
          <p
            dangerouslySetInnerHTML={{ __html: i18n.SOCALGAS_OPPORTUNITY_TEXT }}
          ></p>
          <p
            dangerouslySetInnerHTML={{ __html: i18n.SOCALGAS_OPPORTUNITY_TEXT_P2 }}
          ></p>
        </div>

      </div>

      <div style={styles.footer}>
        <Footer />
      </div>

      <SubscribeEmailModal
        i18n={i18n}
        show={showEmail}
        onClose={() => setShowEmail(false)}
      />
      <SubscribeNumberModal
        i18n={i18n}
        show={showSms}
        onClose={() => setShowSms(false)}
      />
    </div>
  );
}

const styles = {
  header: {
    minHeight: "10vh",
  },
  body: {
    minHeight: "60vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 20
  },
  disclaimer: {
    paddingTop: 30,
    paddingBottom: 10
  },
  footer: {
    borderTop: "1px solid #eee"
  },

};

export default HomeScreen;
